import { Component, OnInit } from '@angular/core';
import { MyProfileService } from 'src/services/my-profile';
import { NiceScrollService } from '../_services/nice-scroll.service';
import { MyProfileModel } from 'src/model/My_Profile/My_Profile';
import { AuthenticationService } from '../_services';
import { Title } from '@angular/platform-browser';
import { LoaderService } from '../_services/loader.service';
declare var $: any;

@Component({
    selector: 'app-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.css'],
    standalone: false
})
export class MyProfileComponent implements OnInit {

  public imagePath;
  userProfile: MyProfileModel;
  ErrorMessage: string;
  FullName: string;
  ProfileImageUrl: any;
  Image: File;
  constructor(private myProfileService: MyProfileService, private authenticationService: AuthenticationService, private title: Title,
              private loader: LoaderService,
              private niceScroll: NiceScrollService
              ) {
                niceScroll.scrollToTop();
              }

  ngOnInit() {
    this.getUser();
    this.setUserName();
    this.title.setTitle(this.FullName + ' | Profile | pakmatti.com');
  }

  public getUser() {
    this.loader.showLoader();
    this.myProfileService.getUserProfile().subscribe(userProfile => {
      this.userProfile = userProfile;
      this.loader.hideLoader();
    });
  }

  public setUserName() {
    const applicationUser = JSON.parse(localStorage.getItem('currentUser'));
    this.FullName = applicationUser.FirstName + ' ' + applicationUser.LastName;
    this.ProfileImageUrl = applicationUser.ImageUrl;
  }

  preview(files) {
    if (files.length === 0) {
      return;
    }
    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.ErrorMessage = 'Only images are supported.';
      $('#Search-Warning2').fadeIn();
      setTimeout(() => {
        $('#Search-Warning2').fadeOut('slow');
      }, 2000);
      return;
    }

    const reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (event) => {
      this.ProfileImageUrl = reader.result;
    };
  }

  Logout(): void {
    this.authenticationService.logout();
  }

  Submit() {
    this.myProfileService.PostService('', '').subscribe(userProfile => {
      this.userProfile = userProfile;
    });
  }
}
